import { GOOGLE_CONSENT_LOCAL_STORAGE_ID } from '../constants';
const GOOGLE_MAPS = { tag: 'maps\\.(googleapis|gstatic)\\.com', displayName: 'Google Maps' };
const GOOGLE_MAPS_API = { tag: 'maps\\.googleapis\\.com', displayName: 'Google - Google Maps API' };
const saveConsentToStorage = (consent, epmModal = false) => {
    var _a;
    if (typeof window !== 'undefined') {
        const gateway = (_a = window === null || window === void 0 ? void 0 : window.Bootstrapper) === null || _a === void 0 ? void 0 : _a.gateway;
        if (consent) {
            if (gateway && gateway.getUserPreference && !epmModal) {
                gateway.setCookie('External Content', '1');
                gateway.updatePreferences();
                gateway.allowTag(GOOGLE_MAPS);
                gateway.allowTag(GOOGLE_MAPS_API);
                gateway.updatePreferences();
                const googleConsent = {
                    consent,
                    expiresOn: Date.now() + 180 * 24 * 60 * 60 * 1000,
                };
                localStorage.setItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID, JSON.stringify(googleConsent));
                window.dispatchEvent(new Event('storage'));
                return;
            }
            const googleConsent = {
                consent,
                expiresOn: Date.now() + 180 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID, JSON.stringify(googleConsent));
            window.dispatchEvent(new Event('storage'));
        }
        else {
            if (gateway && gateway.getUserPreference && !epmModal) {
                gateway.setCookie('External Content', '0');
                gateway.updatePreferences();
                gateway.blockTag(GOOGLE_MAPS);
                gateway.blockTag(GOOGLE_MAPS_API);
                gateway.updatePreferences();
                const googleConsent = {
                    consent,
                    expiresOn: Date.now() + 180 * 24 * 60 * 60 * 1000,
                };
                localStorage.setItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID, JSON.stringify(googleConsent));
                window.dispatchEvent(new Event('storage'));
                return;
            }
            const googleConsent = {
                consent,
                expiresOn: Date.now() + 180 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(GOOGLE_CONSENT_LOCAL_STORAGE_ID, JSON.stringify(googleConsent));
            window.dispatchEvent(new Event('storage'));
        }
    }
};
export default saveConsentToStorage;
